import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconThumbsDownProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconThumbsDown: React.FC<IconThumbsDownProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Dislike',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 14V2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconThumbsDown;
